import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/projects'

/**
 * Environment context attribute value service.
 */
class EnvironmentContextAttributeValueService {
    /**
     * List context attribute values for an environment.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @returns {Promise<Object>} Attribute values response
     */
    async list(projectKey, environmentKey) {
        return await apiClient
            .get(
                API_INTERNAL_BASE +
                    '/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/context-attributes-values'
            )
            .then((response) => {
                return response.data
            })
    }
}

export default new EnvironmentContextAttributeValueService()
